export default __webpack_public_path__ + "static/media/tf1.6d9b645c.svg";